import AceCodeEditorContainer from "../../../../Components/Miscellaneous/Editors/AceCodeEditor/AceCodeEditorContainer";

const AceCodeEditor = () => {
  return <AceCodeEditorContainer />;
};

export default AceCodeEditor;
